<template>
  <div>
    <div
      :class="claseSeccionValidacion(comprador.validacionKyc, true)"
    >
      <FormularioCompradorFisico
        :indice="indice"
        :comprador.sync="comprador"
        :bloquearCampos="!readonly && bloquearCampos"
        :readonly="readonly"
        :guardarYEnviar="guardarYEnviar"
        :guardandoDatos="waitingForLoad || cargandoExterior"
        @autocompletar="autorellenarCompradorKyc"
      />
      <div v-if="fullKyc">
        <v-layout wrap v-if="getGenerarContratoKyc">
          <v-flex xs12 md6 px-2>
            <v-select
              :items="getPropositosContractuales"
              item-text="descripcionPropositoContractual"
              item-value="codigoPropositoContractual"
              :label="$t('reservas.kyc.propositoContractual')"
              :name="'propositoContractual[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar)]"
              v-model="comprador.codigoPropositoContractual"
              :readonly="readonly"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="getGenerarContratoKyc">
          <v-flex xs12 md12 px-2>
            <v-select
              multiple
              :items="getOrigenFondos"
              item-text="descripcionOrigenFondos"
              item-value="codigoOrigenFondos"
              :label="$t('reservas.kyc.origenFondos')"
              :name="'origenFondos[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar)]"
              :value="comprador.origenFondos"
              @input="comprador.origenFondos = $event"
              :readonly="readonly"
            />
          </v-flex>
        </v-layout>
        <v-radio-group
          v-model="comprador.kyc.actividadProfesional"
          :rules="[rules.requiredIf(guardarYEnviar)]"
          row
          class="fullWidth"
          :disabled="readonly"
        >
          <v-layout wrap align-center justify-center>
            <v-flex
              xs12
              md4
              px-2
              v-for="actividad in actividadesProfesionales"
              :key="actividad.value"
            >
              <v-radio
                :label="actividad.text"
                :value="actividad.value"
                class="mb-0"
                color="primary"
              />
            </v-flex>
          </v-layout>
        </v-radio-group>
        <v-slide-y-transition mode="out-in" v-if="getGenerarContratoKyc">
          <div class="mb-3" key="cuentaAjena" v-if="comprador.kyc.actividadProfesional === 'cuentaAjena'">
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-autocomplete
                  :items="getProfesiones"
                  item-text="descripcionProfesion"
                  item-value="codigoProfesion"
                  :label="$t('reservas.kyc.profesion')"
                  :name="'profesion[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar)]"
                  v-model="comprador.kyc.codigoProfesion"
                  :readonly="readonly"
                  :clearable="!readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-text-field
                  :label="$t('reservas.kyc.nombreEmpresa')"
                  :name="'nombreEmpresa[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.max(40)]"
                  v-model="comprador.kyc.ajenaNombreEmpresa"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-text-field
                  :label="$t('reservas.kyc.cargo')"
                  :name="'cargo[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.max(40)]"
                  v-model="comprador.kyc.ajenaCargo"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-numeric-text-field
                  :label="$t('reservas.kyc.anoInicio')"
                  :name="'antiguedadLaboral[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.mayorIgual(0), rules.menorIgual(ano), rules.integerNumber]"
                  v-model="comprador.kyc.ajenaAntiguedadLaboral"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
          </div>
          <div class="mb-3" key="cuentaPropia" v-if="comprador.kyc.actividadProfesional === 'cuentaPropia'">
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-autocomplete
                  :items="getProfesiones"
                  item-text="descripcionProfesion"
                  item-value="codigoProfesion"
                  :label="$t('reservas.kyc.profesion')"
                  :name="'profesion[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar)]"
                  v-model="comprador.kyc.codigoProfesion"
                  :readonly="readonly"
                  :clearable="!readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-text-field
                  :label="$t('reservas.kyc.nombreSociedad')"
                  :name="'nombreSociedad[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                  v-model="comprador.kyc.propiaNombreSociedad"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <o-numeric-text-field
                  :label="$t('reservas.kyc.porcentajePropiedad')"
                  :name="'porcentajePropiedad[' + indice + ']'"
                  :rulesProps="[rules.requiredIf(guardarYEnviar), rules.porcentaje]"
                  v-model="comprador.kyc.propiaPorcentajeSociedad"
                  suffix="%"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <o-numeric-text-field
                  :label="$t('reservas.kyc.volumenNegocio')"
                  :name="'volumenNegocio[' + indice + ']'"
                  :rulesProps="[rules.requiredIf(guardarYEnviar), rules.mayorIgual(0), rules.menor(Math.pow(10, 10))]"
                  v-model="comprador.kyc.propiaVolumenSociedad"
                  suffix="€"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-numeric-text-field
                  :label="$t('reservas.kyc.anoInicio')"
                  :name="'inicioActividad[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.mayorIgual(0), rules.menorIgual(ano), rules.integerNumber]"
                  v-model="comprador.kyc.propiaAnoInicioSociedad"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
          </div>
          <div class="mb-3" key="sinActividad" v-if="comprador.kyc.actividadProfesional === 'sinActividad'">
            <v-layout wrap>
              <v-flex xs12 px-2>
                <v-select
                  :items="actividadesNoProfesionales"
                  v-model="comprador.kyc.sinActividadMotivo"
                  :label="$t('reservas.kyc.motivoInactividad')"
                  :name="'motivoActividad[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar)]"
                  :readonly="readonly"
                />
              </v-flex>
            </v-layout>
            <v-slide-y-transition mode="out-in">
              <v-layout wrap key="jubilado" v-if="comprador.kyc.sinActividadMotivo === 'jubilado'">
                <v-flex xs12 px-2>
                  <v-autocomplete
                    :items="getProfesiones"
                    item-text="descripcionProfesion"
                    item-value="codigoProfesion"
                    :label="$t('reservas.kyc.profesionEjercida')"
                    :name="'profesionEjercida[' + indice + ']'"
                    :rules="[rules.requiredIf(guardarYEnviar)]"
                    v-model="comprador.kyc.jubiladoCodigoProfesion"
                    :readonly="readonly"
                    :clearable="!readonly"
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap key="pensionista" v-if="comprador.kyc.sinActividadMotivo === 'pensionista'">
                <v-flex xs12 px-2>
                  <v-text-field
                    :label="$t('reservas.kyc.pensionado')"
                    :name="'conceptoPension[' + indice + ']'"
                    :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                    v-model="comprador.kyc.pensionistaConcepto"
                    :readonly="readonly"
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap key="rentista" v-if="comprador.kyc.sinActividadMotivo === 'rentista'">
                <v-flex xs12 px-2>
                  <o-numeric-text-field
                    :label="$t('reservas.kyc.volumenRentas')"
                    :name="'volumenRentas[' + indice + ']'"
                    :rulesProps="[rules.requiredIf(guardarYEnviar), rules.mayorIgual(0), rules.menor(Math.pow(10, 10))]"
                    v-model="comprador.kyc.rentistaVolumen"
                    :readonly="readonly"
                    suffix="€"
                  />
                </v-flex>
              </v-layout>
            </v-slide-y-transition>
          </div>
        </v-slide-y-transition>
        <v-layout wrap px-2 my-4 v-if="getGenerarContratoKyc">
          <v-flex xs12>
            <label class="theme--light v-label">
             {{$t('reservas.kyc.cargosPublicos')}}
            </label>
          </v-flex>
        </v-layout>
        <v-radio-group
          v-if="getGenerarContratoKyc"
          class="mt-1 px-2"
          v-model="comprador.cargoPublico"
          :rules="[rules.requiredIf(guardarYEnviar)]"
          row
          :disabled="readonly"  
        >
          <v-radio
            color="primary"
            :label="$t('reservas.kyc.si')"
            :value="true"
            class="mb-0"
          />
          <v-radio
            color="primary"
            :label="$t('reservas.kyc.no')"
            :value="false"
            class="mb-0"
          />
        </v-radio-group>
        <v-slide-y-transition>
          <div class="mb-3" v-if="comprador.cargoPublico && getGenerarContratoKyc">
            <v-layout wrap>
              <v-flex xs12 md4  px-2>
                <v-text-field
                  :label="$t('reservas.kyc.parentesco')"
                  :name="'parentesco[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                  v-model="comprador.kyc.cargoPublicoParentesco"
                  :readonly="readonly"
                />
              </v-flex>
              <v-flex xs12 md4 px-2>
                <v-text-field
                  :label="$t('reservas.kyc.cargo')"
                  :name="'cargo[' + indice + ']'"
                  :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                  v-model="comprador.kyc.cargoPublicoCargo"
                  :readonly="readonly"
                />
              </v-flex>
              <v-flex xs12 md4 px-2>
                <v-autocomplete
                  :label="$t('reservas.kyc.pais')"
                  :name="'pais[' + indice + ']'"
                  :items="getPaises"
                  item-text="denominacionPais"
                  item-value="codigoPais"
                  :rules="[rules.requiredIf(guardarYEnviar)]"
                  v-model="comprador.kyc.cargoPublicoCodigoPais"
                  :readonly="readonly"
                  :clearable="!readonly"
                  browser-autocomplete="OVERFISICOPAIS"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-slide-y-transition>
      
          <v-flex mb-2 shrink v-if="fullKyc && revisando">
            <v-btn
              block
              color="primary"
              @click="comprador.validacionKyc.datosCompradorValidos = !comprador.validacionKyc.datosCompradorValidos"
              hide-details
            >
            {{comprador.validacionKyc.datosCompradorValidos ? $t('reservas.kyc.rechazarSeccion') : $t('reservas.kyc.validarSeccion')}}
            </v-btn>
        </v-flex>
      
      </div>
    </div>
    <div
      :class="claseSeccionValidacion(comprador.validacionKyc, false)"
      v-if="fullKyc && getGenerarContratoKyc"
    >
      <v-layout :mb-1="comprador.kyc.representante">
        <v-flex xs12 px-2>
          <v-layout row justify-start align-center>
            <v-layout shrink>
              <v-checkbox
                v-model="comprador.kyc.representante"
                color="primary"
                :label="$t('reservas.kyc.actuaRepresentante')"
                :true-value="true"
                :false-value="false"
                :disabled="readonly"
              >
              <template slot="label">
                {{$t('reservas.kyc.actuaRepresentante')}}
                <v-tooltip bottom>
                  <template #activator="{on}">
                    <v-icon class="pl-1 pb-2" small v-on="on" @click.stop>
                      info
                    </v-icon>
                  </template>
                  <span>{{$t('reservas.kyc.checkActuaRepresentante', {reserva: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.kyc.comprador') : $t('reservas.kyc.arrendatario')})}}</span>
                </v-tooltip>
              </template>
              </v-checkbox>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-slide-y-transition>
        <div v-if="comprador.kyc.representante">
          <v-layout wrap>
            <v-flex xs12 px-2>
              <v-radio-group
                v-model="comprador.kyc.representanteJuridico"
                row
                :rules="[rules.requiredIf(guardarYEnviar)]"
                :readonly="readonly"
                class="mt-0"
                @change="cambiarJuridicoRepresentante()"
              >
                <template #label>
                  {{$t('promociones.tipoPersona')}}
                </template>
                <v-radio
                    :label="$t('promociones.fisica')"
                    :value="false"
                    color="primary"
                  />
                  <v-radio
                    :label="$t('promociones.juridica')"
                    :value="true"
                    color="primary"
                  />
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-slide-y-transition>
          <v-layout wrap v-if="comprador.kyc.representanteJuridico !== null">
            <v-flex xs12 md6 px-2>
              <v-select
                v-if="!comprador.kyc.representanteJuridico"
                :label="$t('comerciales.tipoDocumento')"
                :name="'tipoDocumentoID[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar)]"
                :items="getTiposDocumentos"
                item-text="DESC_TIPO_DOCUMENTO_ID"
                item-value="COD_TIPO_DOCUMENTO_ID"
                v-model="comprador.kyc.representanteTipoDocumento"
                :disabled="bloquearCampos"
                :readonly="readonly"
              />
              <v-select
                v-else
                :label="$t('reservas.formularioJuridico.tipoDocumento')"
                :name="'tipoDocumentoID[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar)]"
                :items="[{DESC_TIPO_DOCUMENTO_ID: 'CIF', COD_TIPO_DOCUMENTO_ID: 'C'}]"
                item-text="DESC_TIPO_DOCUMENTO_ID"
                item-value="COD_TIPO_DOCUMENTO_ID"
                v-model="comprador.kyc.representanteTipoDocumento"
                :disabled="true"
                :readonly="readonly"
              />
            </v-flex>
            <v-flex xs12 md6 px-2>
              <v-text-field
                :label="$t('comerciales.numDocumento')"
                :name="'dniPasaporte[' + indice + ']'"
                :value="comprador.kyc.representanteDni"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(20), rules.numberUppercase, rules.validarIf(guardarYEnviar, comprador.kyc.representanteJuridico ? rules.validarCif(comprador.kyc.representanteTipoDocumento) : rules.validarNif(comprador.kyc.representanteTipoDocumento))]"
                @input="comprador.kyc.representanteDni = $event != null ? $event.toUpperCase() : $event"
                :readonly="readonly"
              />
            </v-flex>
            <v-flex xs12 px-2 v-if="!comprador.kyc.representanteJuridico">
              <v-select
                :label="$t('reservas.formularioFisico.sexo')"
                :name="'codigoGenero[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar)]"
                :items="generos"
                item-text="text"
                item-value="value"
                v-model="comprador.kyc.representanteCodigoGenero"
                :disabled="bloquearCampos"
                :readonly="readonly"
              />
            </v-flex>
            <v-flex xs12 px-2 v-if="comprador.kyc.representanteJuridico">
              <v-text-field
                :label="$t('reservas.kyc.nombreDenominacionJuridica')"
                :name="'nombreApellidos[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(250)]"
                v-model="comprador.kyc.representanteDenominacionSocial"
                :readonly="readonly"
                browser-autocomplete="OVERREPRESENTANTEDENOMINACIONSOCIAL"
              />
            </v-flex>
            <v-flex xs12 md6 px-2>
              <v-text-field
                :label="$t('reservas.kyc.representanteNombre')"
                :name="'nombreApellidos[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                v-model="comprador.kyc.representanteNombre"
                :readonly="readonly"
                browser-autocomplete="OVERREPRESENTANTENOMBRE"
              />
            </v-flex>
            <v-flex xs12 md6 px-2>
              <v-text-field
                :label="$t('reservas.kyc.representanteApellido')"
                :name="'nombreApellidos[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                v-model="comprador.kyc.representanteApellido"
                :readonly="readonly"
                browser-autocomplete="OVERREPRESENTANTEAPELLIDO"
              />
            </v-flex>
            <v-flex xs12 px-2>
              <v-autocomplete
                :label="$t('reservas.kyc.nacionalidad')"
                :name="'nacionalidad[' + indice + ']'"
                :items="getNacionalidades"
                item-text="denominacionNacionalidad"
                item-value="codigoNacionalidad"
                v-model="comprador.kyc.representanteCodigoNacionalidad"
                :rules="[rules.requiredIf(guardarYEnviar)]"
                :readonly="readonly"
                :clearable="!readonly"
              />
            </v-flex>
            <v-flex xs12 px-2>
              <v-text-field
                :label="$t('reservas.kyc.numeroEscritura')"
                :name="'numeroEscritura[' + indice + ']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(10)]"
                v-model="comprador.kyc.representanteEscritura"
                :readonly="readonly"
                browser-autocomplete="OVERREPRESENTANTENUMEROESCRITURA"
              />
            </v-flex>
            <v-flex xs12 px-2>
              <o-date-picker
                :label="$t('reservas.kyc.fechaEscritura')"
                :name="'fechaEscritura[' + indice + ']'"
                :obligatorio="guardarYEnviar"
                v-model="comprador.kyc.representanteEscrituraFecha"
                :readonly="readonly"
                :extraYearsMax="0"
              />
            </v-flex>
          </v-layout>
          </v-slide-y-transition>
        </div>
          
      </v-slide-y-transition>
      <v-flex mb-2 shrink v-if="fullKyc && revisando">
            <v-btn
              block
              color="primary"
              @click="comprador.validacionKyc.datosRepresentanteValidos = !comprador.validacionKyc.datosRepresentanteValidos"
              hide-details
            >
            {{comprador.validacionKyc.datosRepresentanteValidos ? $t('reservas.kyc.rechazarSeccion') : $t('reservas.kyc.validarSeccion')}}
            </v-btn>
        </v-flex>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import rules from '@/mixins/rules'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoKyc from '@/mixins/estadosReserva/estadoKyc'
import FormularioCompradorFisico from '@/components/reservas/comprador/FormularioCompradorFisico'
import moment from 'moment'

export default {
  mixins: [rules, MixinComprador, MixinEstadoKyc],
  props: {
    comprador: {
      type: Object,
      required: true
    },
    incrustado: {
      type: Boolean,
      default: false
    },
    indice: {
      type: Number,
      default: 0
    },
    fullKyc: {
      type: Boolean,
      default: true
    },
    bloquearCampos: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    revisando: {
      type: Boolean,
      default: false
    },
    guardarYEnviar: {
      type: Boolean,
      default: false
    },
    waitingForLoad: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormularioCompradorFisico
  },
  data () {
    return {
      menuFechaNacimiento: false
    }
  },
  computed: {
    ...mapGetters({
      getOrigenFondos: 'maestros/origenFondos/getAll',
      getPropositosContractuales: 'maestros/propositosContractuales/getAll',
      getProfesiones: 'maestros/profesiones/getAll',
      getPaises: 'maestros/paises/getAll',
      reserva: 'reservas/_id/getActual',
      getNacionalidades: 'maestros/nacionalidades/getAll',
      getGenerarContratoKyc: 'modulosOrdenes/getGenerarContratoKyc',
      getTiposDocumentos: 'maestros/tiposDocumentos/getAll'
    }),
    ano () {
      return moment().year()
    }
  },
  methods: {
    formatDate (d) {
      return d ? moment(d).format('DD/MM/YYYY') : null
    },
    claseSeccionValidacion (validacionKyc, isDatosComprador) {
      // Devuelve true o false según si los datos del kyc son de comprador o representante
      let valido = false
      if (validacionKyc != null) {
        valido = isDatosComprador ? validacionKyc.datosCompradorValidos : validacionKyc.datosRepresentanteValidos
      }
      return (!this.kycVer || this.revisando) && validacionKyc != null
        ? ['px-2', 'my-2', 'section', valido ? 'section-validado' : 'section-rechazado']
        : []
    },
    cambiarJuridicoRepresentante() {
      if (this.comprador.kyc.representanteJuridico) {
        this.comprador.kyc.representanteTipoDocumento = 'C'
      } else if (this.comprador.kyc.representanteTipoDocumento === 'C') {
        this.comprador.kyc.representanteTipoDocumento = null
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~vuetify/src/stylus/settings/_colors'

.fullWidth.v-input--selection-controls .v-input__control
  width: 100% !important

</style>




// WEBPACK FOOTER //
// src/components/reservas/kyc/KycCompradorFisico.vue